import { useCallback } from 'react';

import Modal from '../Modal';
import EditProfileContractorForm from '../../forms/EditProfileContractorForm';
import EditProfileAssignorForm from '../../forms/EditProfileAssignorForm';
import SupervisorEditForm from '../../forms/EditProfileSupervisorForm';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: any) => Promise<void>;
  initialValues: any;
  userRole: string;
}

const EditProfileModal = ({
  initialValues,
  isOpen,
  onClose,
  onSubmit,
  userRole,
}: Props) => {
  const renderEditForm = useCallback(() => {
    switch (userRole) {
      case 'CONTRACTOR':
        return (
          <EditProfileContractorForm
            initialValues={initialValues}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        );
      case 'ASSIGNOR':
        return (
          <EditProfileAssignorForm
            initialValues={initialValues}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        );
      case 'SUPERVISOR':
        return (
          <SupervisorEditForm
            initialValues={initialValues}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        );
      default:
        return <h2 className="flex text-xl w-full border p-4 mt-3">Invalid user role</h2>;
    }
  }, [userRole, initialValues, onClose, onSubmit]);

  return (
    <Modal isOpen={isOpen} maxWidth="35rem">
      <div className="flex flex-col bg-white rounded-xl w-full mx-auto py-6 gap-5">
        <div>
          <h2 className="px-6 text-xl font-bold">Edit Profile</h2>
          <p className="px-6 text-[#475467]">Change your personal details</p>
        </div>
        <h3 className="px-6 font-bold">Personal details</h3>
        {renderEditForm()}
      </div>
    </Modal>
  );
};

export default EditProfileModal;
